export default function useIFramed() {
	return window.location !== window.parent.location;
}
